import createClient from 'openapi-fetch'
import type { components, paths } from './gen/payables'
import { authFetch, call } from './http'
import { isoDaysAgo } from '../lib/money'

export type PayablesSchemas = components['schemas']
export type Payable = PayablesSchemas['Payable']
export type PayableStatus = PayablesSchemas['PayableStatus']
export type Line = PayablesSchemas['Line']
export type Vendor = PayablesSchemas['Vendor']
export type TrendPoint = PayablesSchemas['TrendPoint']
export type PayablesSummary = PayablesSchemas['Summary']
export type PayableQuery = NonNullable<paths['/payables']['get']['parameters']['query']>

const origin = typeof location !== 'undefined' ? location.origin : 'http://localhost'

export const payables = createClient<paths>({ baseUrl: `${origin}/api/payables`, fetch: authFetch })

export const BILL_TABS = ['draft', 'open', 'overdue', 'paid', 'all'] as const
export type BillTab = (typeof BILL_TABS)[number]

/** Tab + vendor search → list query. Overdue = open with a due date before today. */
export function payablesQuery(tab: BillTab, q = '', cursor?: string, limit = 50): PayableQuery {
  const base: PayableQuery = tab === 'all' ? {} : tab === 'overdue' ? { status: 'open', to: isoDaysAgo(1) } : { status: tab }
  return { ...base, ...(q.trim() ? { q: q.trim() } : {}), ...(cursor ? { cursor } : {}), limit }
}

export const listPayables = (tab: BillTab, q = '', cursor?: string) =>
  call(payables.GET('/payables', { params: { query: payablesQuery(tab, q, cursor) } }))

export const isOverdue = (p: Pick<Payable, 'status' | 'due_date'>, today = isoDaysAgo(0)) =>
  p.status === 'open' && !!p.due_date && p.due_date < today

export const lineTrends = (vendor: string, description?: string) =>
  call(payables.GET('/lines/trends', { params: { query: { vendor, ...(description ? { description } : {}) } } }))
